import { render } from "./acctrans-apply.vue?vue&type=template&id=4348731d&scoped=true"
import script from "./acctrans-apply.vue?vue&type=script&lang=js"
export * from "./acctrans-apply.vue?vue&type=script&lang=js"

import "./acctrans-apply.vue?vue&type=style&index=0&id=4348731d&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4348731d"]])

export default __exports__